import React from 'react';
import { getAnchorId } from '@/helpers/utils';
import Divider from '../common/Divider';

interface FAQ {
  title: string;
  body: string;
}

interface FAQsProps {
  faqs: FAQ[];
  sectionHeader: string;
}

const FAQs: React.FC<FAQsProps> = ({ faqs, sectionHeader }) => {
  return (
    <div className="flex tw-justify-center">
      <div className="w-full tw-max-w-xl">
        <h2 className="margin-3-b color-text-emphasis tw-font-sans tw-text-2xl">
          {sectionHeader}
        </h2>
        {faqs.map((faq, idx) => {
          const anchorInput = {
            type: 'faq',
            name: undefined,
            title: faq.title,
            idx,
            section: sectionHeader,
          };
          return (
            <div
              key={faq.title}
              id={getAnchorId(anchorInput)}
              className={idx !== 0 ? 'tw-mt-12' : 'tw-mt-4'}
            >
              <div className="tw-text-md tw-mb-2 tw-font-sans tw-font-bold md_tw-text-lg">
                {faq.title}
              </div>
              <div
                className="md_tw-text-md tw-mb-4 tw-text-sm a-children_tw-text-blue-bright-600 a-children_tw-underline"
                dangerouslySetInnerHTML={{ __html: faq.body }}
              />
              {idx < faqs.length - 1 && <Divider />}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FAQs;
